import Constant from '@/constant';

export default {
    [Constant.INITIALIZE_CARD_INFO]: (state, payload) => {
        state.card = {     
            receptionNumber: "",
            cardNumber: "",
            cardPw: "",
            cardExMonth: "",
            cardExYear: "",
            cardNickName: "",
            cardUserName: "", 
            cardUserBirth: ""
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js